// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyCMTk1YK8Eu_cpXpwGHxXmX3RSX1VNFw2Q",
        authDomain: "time-premiado.firebaseapp.com",
        databaseURL: "https://time-premiado.firebaseio.com",
        projectId: "time-premiado",
        storageBucket: "time-premiado.appspot.com",
        messagingSenderId: "135110166219",
        appId: "1:135110166219:web:12a7e0fa05aa11e6befd4e",
        measurementId: "G-X2HWPVBLLT"
    },
    appleStoreId: '1541081204',
    googleStoreId: 'br.com.icons4u.timepremiado',
    googleMapsApiKey: 'AIzaSyAuQXtBFboYfCZoWuAdqybfAphPbOmudZg',
    config: {
        local: {
            _site: 'https://app.dev.timepremiado.app.br/',
            _media: 'https://media.timepremiado.app.br/',
            urlApiPadrao: 'http://localhost:3012/',
            // urlApiPadrao: 'https://api.timepremiado.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        dev: {
            _site: 'https://app.dev.timepremiado.app.br/',
            _media: 'https://media.timepremiado.app.br/',
            // urlApiPadrao: 'https://api.dev.timepremiado.app.br/',
            urlApiPadrao: 'https://api.timepremiado.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        hom: {
            _site: 'https://app.hom.timepremiado.app.br/',
            _media: 'https://media.timepremiado.app.br/',
            urlApiPadrao: 'https://api.dev.timepremiado.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        },
        prod: {
            _site: 'https://app.timepremiado.app.br/',
            _media: 'https://media.timepremiado.app.br/',
            urlApiPadrao: 'https://api.timepremiado.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/prod',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        }
    },
    version: '2026.11.05'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
